import script from "./FooterLink.vue?vue&type=script&lang=js&setup=true"
export * from "./FooterLink.vue?vue&type=script&lang=js&setup=true"

const __exports__ = script;

export default __exports__